import { FuseNavigationItem } from '@fuse/components/navigation';
import { Role } from 'app/shared/enums/role';
import { TenantFeatures } from 'app/shared/types/tenant-settings.types';
import { isTutorRole } from 'app/shared/utils/role-utils';

export const navigationByRole = (role: Role, features: TenantFeatures | null): FuseNavigationItem[] => {
    if (isTutorRole(role)) {
        return [
            {
                id: 'monthly-course-calendar',
                title: 'My Calendar',
                type: 'basic',
                icon: 'heroicons_outline:calendar-days',
                link: '/calendars/monthly-course'
            }
        ];
    }

    const items: FuseNavigationItem[] = [
        {
            id: 'calendars',
            title: 'Calendars',
            type: 'collapsable',
            icon: 'heroicons_outline:calendar-days',
            children: [
                {
                    id: 'monthly-course-calendar',
                    title: 'Course',
                    type: 'basic',
                    icon: 'heroicons_outline:calendar-days',
                    link: '/calendars/monthly-course'
                },
                {
                    id: 'weekly-resource-calendar',
                    title: 'Weekly Resource',
                    type: 'basic',
                    icon: 'heroicons_outline:calendar-days',
                    link: '/calendars/weekly-resource'
                },
                {
                    id: 'monthly-resource-calendar',
                    title: 'Monthly Resource',
                    type: 'basic',
                    icon: 'heroicons_outline:calendar-days',
                    link: '/calendars/monthly-resource'
                },
            ]
        },
        {
            id: 'companies',
            title: 'Companies',
            type: 'basic',
            icon: 'heroicons_outline:building-office',
            link: '/companies'
        },
        {
            id: 'delegates',
            title: 'Delegates',
            type: 'basic',
            icon: 'heroicons_outline:users',
            link: '/delegates'
        },
    ];

    if (features?.deal) {
        items.push({
            id: 'deals',
            title: 'Deals',
            type: 'basic',
            icon: 'heroicons_outline:currency-dollar',
            link: '/deals'
        });
    }

    items.push(
        {
            id: 'courses',
            title: 'Courses',
            type: 'basic',
            icon: 'heroicons_outline:academic-cap',
            link: '/courses'
        },
        {
            id: 'schedules',
            title: 'Schedules',
            type: 'basic',
            icon: 'heroicons_outline:clock',
            link: '/schedules'
        },
        {
            id: 'bookings',
            title: 'Bookings',
            type: 'basic',
            icon: 'heroicons_outline:clipboard-document-check',
            link: '/bookings'
        },
        {
            id: 'reporting',
            title: 'Reporting',
            type: 'basic',
            icon: 'heroicons_outline:document-chart-bar',
            link: '/reporting'
        }
    );

    return items;
};
